<template>
  <div>
    <div class="header-container" v-if="dataTemplateQMAOrientacao.length > 0">
      <div v-for="(data,index) in dataTemplateQMAOrientacao" v-bind:key="index">
        <div  class="container-orientacao">
          <div class="button-epi-selecionado">
            <div v-if="data.add === true">
              <div class="button-lista" :id="data.id" @click="AdicionarItenParaExclusaoDaEdicao(data)"><i class="fas fa-check" style="color: rgb(19, 59, 26); font-size: 9px;" v-if="data.check === true"></i></div>
            </div>

          </div>
          <div class="orientacao">
              {{ data.nivelPrioridade === null || data.nivelPrioridade === undefined ?  data.descricao : data.nivelPrioridade  + ' - ' + data.descricao }}
            <div class="label_descricao" v-if="data.edicao === true">
              <div class="tag">
                <div class="tag_identificacao" :style="{'background-color': data.colorStatus, 'color': data.colorFonte}"> {{ data.descricaoEdicao }}</div>
              </div>
            </div>
          </div>

          <div class="switch-container">
          <!-- <label class="switch">
            <input type="checkbox" @click="CheckboxAtivacaoInativacao(data.id, data.status)" :id="data.id" :checked="data.status" :disabled="data.edicao === true ? true : false">
            <span class="slider round"></span>
          </label> -->
            <div class="subEtapa_detalhes">
              <i v-b-tooltip.hover :title="'Abrir imagem'" class="fas fa-eye iconImg" v-if="data.imagem === true" @click="downloadOrientacaoImagem(data.urlImagem, data.nomeArquivo)"></i>
            </div>
            <div class="subEtapa_detalhes">
              <i v-b-tooltip.hover :title="'Editar Nível de prioridade da Orientação'" v-if="data.excluir === false" class="fas fa-edit" @click="Editarorientacao(data.id, data.nivelPrioridade)"></i>
            </div>
            <div class="subEtapa_detalhes">
              <i v-b-tooltip.hover :title="'Excluir Orientação'" v-if="data.excluir === false" class="fas fa-trash" @click="popUpExcluir(data)"></i>
            </div>
            <div class="icon_container" v-if="data.excluir === true">
                  <i class="fas fa-times" style="color: rgb(136, 22, 22); font-size: 14px" v-b-tooltip.hover :title="data.excluir == true ? 'Remover Edições do tipo Exclusão' : 'Remover Novo Item'" @click="removerdeleteOrientacao(data.id)"></i>
                </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container_img" v-else>
      <img  class="img_notFound" :src="notFound">
      <div class="titulo_sem_registro">Nenhum registro encontrado</div>
      <div class="subtitulo_sem_registro">Adicione um novo registro para iniciar as orientações</div>
      <button class="button" @click="addorientacao">
          <i class="fas fa-plus"></i>ADICIONAR REGISTRO
      </button>
    </div>
    <div id="myModal" class="modal">
      <span class="close" @click="fecharModal">&times;</span>
      <img class="modal-content" id="img01">
      <div id="caption"></div>
    </div>

    <deleteQuestion
          ref="modal_Excluir_Orientacao"
          :templateid="templateid"
          @deleteOrientacao="deleteOrientacao">
    </deleteQuestion>
  </div>

  </template>

<script>
import guidanceTemplate from './guidanceTemplate'
export default guidanceTemplate
</script>
  <style scoped>
  .subEtapa_detalhes {
    display: flex;
    justify-content: end;
    align-items: center;
    color: #717171
  }
  .img_tipo_campo {
    width: 2rem;
    padding: 0 0.4rem 0 0.4rem
  }
  .button-epi-selecionado{
    display: flex;
    width: 5%;
    align-items: center;
    justify-content: center;
  }
  .button-lista{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    border-radius: 12%;
    border: 1px solid #c4c4c4;
  }
  .button-lista.clicked {
    background-color: rgb(203, 233, 207); /* Cor de fundo alterada */
    border: 1px solid rgb(81 134 91)
  }
  .check-inpu{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6%;
  }
  .label_descricao{
    padding-left: 1rem;
    margin-right: 1rem;
    margin-left: 1rem;
    border-left: 1px solid rgb(205, 205, 205);
  }
  .header-container{
    margin-top: 1rem;
    width: 100%;
  }
  .tag{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: 20px;
    height: 100%;
    width: 13rem
  }
  .tag_identificacao{
    width: fit-content;
    height: 1.6rem;
    text-align: center;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font: normal normal 600 10px / 24px Segoe UI;
    padding: 0 5px 0 5px;
    font-weight: bold;
  }
  .iconImg {
    margin-left: 4%;
    color: #1C6228;
    font-size: 14px;
  }
  .container-orientacao{
    display: flex;
    padding: 0.3rem 0 0.3rem 0;
    height: fit-content;
    width: 100%;
  }
  .container-orientacao-img{
    display: flex;
    padding: 0.3rem 0 0.3rem 0;
    border-bottom: 1px solid rgb(237 237 237);
    height: fit-content;
    width: 100%;
  }
  .orientacao {
    display: flex;
    padding: 0.5rem;
    justify-content: initial;
    align-items: center;
    width: 100%;
  }
  .switch-container {
    margin-top: 5px;
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: end;
    width: 15%;
  }

  .button{
    margin-top: 2rem;
    font: normal normal 600 12px / 21px Segoe UI;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height: 37px;
    background-color: #008144;
    color: white;
   }
  .container_img{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    align-items: center;
    flex-direction: column;
  }
  .img_notFound{
    width: 20%;
    height: fit-content;
  }
  .titulo_sem_registro {
    margin-top: 1rem;
    font: normal normal normal 28px/33px Segoe UI;
    color: #008148;
  }
  .subtitulo_sem_registro {
    font: normal normal normal 16px/33px Segoe UI;
    letter-spacing: -0.3px;
    color: #4F4C4D;
  }

/* Estilização switch */

.switch {
  position: relative;
  display: inline-block;
  width: 58px;
  height: 31px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #eeeeee;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: #666666;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #CBE9CF;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  background-color: #1C6228;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#myImg {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

#myImg:hover {opacity: 0.7;}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: hidden; /* Hide overflow to prevent scrollbar */
  background-color: rgba(0, 0, 0, 0.9); /* Black with opacity */
}

.modal-content {
  margin: auto;
  display: block;
  max-width: 80%; /* Restrict width */
  background-color: transparent;
  max-height: 80%; /* Restrict height */
  object-fit: contain; /* Ensure the image scales properly */
}

#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: auto;
}

.modal-content, #caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {transform: scale(0);}
  to {transform: scale(1);}
}

.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
    max-height: 70%;
  }
}
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/guidanceTemplate/guidanceTemplate.vue